import type { ImgHTMLAttributes } from "react";

import { useLanguage } from "@/i18n/LanguageContext";

/** Canonical Daaru Na'im crest (transparent PNG). */
export const DAARU_CREST_SRC = "/branding/daarunaim/crest.png";
export const DAARU_CREST_MARK_SRC = "/branding/daarunaim/crest-mark.png";

export type DaaruLogoSize = "sm" | "md" | "lg" | "hero";

const SIZE_CLASS: Record<DaaruLogoSize, string> = {
  sm: "dn-logo dn-logo-sm",
  md: "dn-logo dn-logo-md",
  lg: "dn-logo dn-logo-lg",
  hero: "dn-logo dn-logo-hero",
};

type Props = Omit<ImgHTMLAttributes<HTMLImageElement>, "src" | "alt"> & {
  size?: DaaruLogoSize;
  /** Compact emblem crop for favicon-like spots. */
  mark?: boolean;
  alt?: string;
};

/**
 * Shared brand mark. Transparent areas show the page background —
 * never wrap in a black/white box.
 */
export function DaaruLogo({ size = "md", mark = false, className, alt, ...rest }: Props) {
  const { t } = useLanguage();
  const label = alt ?? t.brandOrg;
  const classes = [SIZE_CLASS[size], className].filter(Boolean).join(" ");
  return (
    <img
      src={mark ? DAARU_CREST_MARK_SRC : DAARU_CREST_SRC}
      alt={label}
      className={classes}
      decoding="async"
      {...rest}
    />
  );
}
